import React, { useState } from "react";
import { Building2, Users, DollarSign } from "lucide-react";
import AdminAnalytics from "./AdminAnalytics";
import ESSAnalytics from "./ESSAnalytics";
import PayrollAnalytics from "./PayrollAnalytics";
import "./Analytics.scss";

const AnalyticsDashboard = () => {
  const [activeTab, setActiveTab] = useState("ess");

  const tabs = [
    { id: "ess", label: "ESS", icon: Users },
    { id: "payroll", label: "Payroll", icon: DollarSign },
    { id: "admin", label: "Admin", icon: Building2 },
  ];

  return (
    <div className="analytics-dashboard">
      <div className="dashboard-tabs">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          return (
            <button
              key={tab.id}
              className={`custom-submenu-item ${
                activeTab === tab.id ? "custom-active" : ""
              }`}
              onClick={() => setActiveTab(tab.id)}
            >
              <Icon size={18} />
              <span>{tab.label}</span>
            </button>
          );
        })}
      </div>

      <div className="dashboard-content">
        {activeTab === "ess" && <ESSAnalytics />}
        {activeTab === "payroll" && <PayrollAnalytics />}
        {activeTab === "admin" && <AdminAnalytics />}
      </div>
    </div>
  );
};

export default AnalyticsDashboard;
